import { render, staticRenderFns } from "./quotation_type_edit.vue?vue&type=template&id=9102a48a&scoped=true"
import script from "./quotation_type_edit.vue?vue&type=script&lang=js"
export * from "./quotation_type_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9102a48a",
  null
  
)

export default component.exports